// apps/frontend/src/hooks/useCommunityUnreadCount.ts
// Badge nav "X nouveaux posts" depuis dernière visite du feed Communauté.
// Polling toutes les 60 s pendant que l'utilisateur navigue dans l'app.

import { useQuery } from '@tanstack/react-query';
import { API_BASE_URL } from '../config/api';
import { useAuth } from './useAuth';

const authHeaders = (): HeadersInit => {
  const token = localStorage.getItem('glowp_access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export function useCommunityUnreadCount(): number {
  const { user, isAuthenticated } = useAuth();
  const { data } = useQuery({
    queryKey: ['community-unread-count', user?.id],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/v1/community/unread-count`, {
        headers: authHeaders(),
      });
      if (!res.ok) return { count: 0 };
      const json = await res.json();
      return (json.data ?? { count: 0 }) as { count: number };
    },
    enabled: !!isAuthenticated && !!user?.id,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  });
  return data?.count ?? 0;
}
